export default __webpack_public_path__ + "static/media/disconnect.a8b6f345.svg";